import {IOriginWrapper} from "~/interfaces/mappingInterfaces";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {ModelType} from "~/enums/modelType";
import {IPaymentStep} from "../../../formability/form_builder/models/workflow/paymentStep";

export default class OriginWrapperPaymentStepLineItem implements IOriginWrapper {
  static readonly type: ModelType.PaymentStepLineItem = ModelType.PaymentStepLineItem
  readonly type: ModelType.PaymentStepLineItem = ModelType.PaymentStepLineItem

  constructor(private step: IPaymentStep) {
  }

  get object(): IPaymentStep {
    return this.step
  }

  get client_id(): string {
    return OriginWrapperPaymentStepLineItem.addSuffix(this.step.client_id)
  }

  get rootIdentifier(): string {
    return this.client_id
  }

  get value(): IDefaultVOption {
    return {label: OriginWrapperPaymentStepLineItem.displayLabel(this.step.titleOrDefault), value: OriginWrapperPaymentStepLineItem.addSuffix(this.step.client_id)}
  }

  static addSuffix(v: string): string {
    return `${v};${this.type}`
  }

  static displayLabel(v: string): string {
    return `Line Items of ${v}`
  }
}